import {ResidenceExplorerResponse} from "features/residenceExplorer/types";

export const collectApartmentsByTopLevel = (data: ResidenceExplorerResponse): Record<string, string[]> => {
    const result: Record<string, string[]> = {};
    const views = data.views;
    const root = views[data.settings.firstView];

    if (!root || !root.clickArea) return result;

    for (const [topNodeKey, topNodeArea] of Object.entries(root.clickArea)) {
        if (topNodeArea.type !== "view") continue;

        const startViewId = topNodeArea.value;
        const visited = new Set<string>();
        const queue = [startViewId];
        const apartments: string[] = [];

        while (queue.length > 0) {
            const currentViewId = queue.shift();
            if (!currentViewId || visited.has(currentViewId)) continue;
            visited.add(currentViewId);

            const view = views[currentViewId];
            if (!view || !view.clickArea) continue;

            for (const area of Object.values(view.clickArea)) {
                if (area.type === "apt") {
                    apartments.push(area.value.toUpperCase());
                }
            }

            const links = Object.values(view.interLink || {}).map(link => link.value);
            queue.push(...links);
        }

        result[topNodeKey] = apartments;
    }

    return result;
};
